/* ================
import
================ */
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import HeightLine from './app/heightline.js';
import CopyRight from './app/copyright.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import buildFormat from './app/format.js';
import myScript from './scripts.js';
import modaal from 'modaal';
import modal from './app/modal.js';
import anime from 'animejs';
import modaalCss from 'modaal/dist/css/modaal.css';

/* ================
window.AddPackagesにいれる
================ */
class AddPackages {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.CopyRight = new CopyRight();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.Tab = new Tab();
    this.defaultOptions = {
      utils: this.Utils
    }
  }
}
window.AddPackages = new AddPackages()
